import api from './client';

export interface TopProduct {
  shopify_id: number;
  title: string;
  revenue: number;
  units: number;
}

export interface TopCustomer {
  shopify_id: number;
  name: string;
  email: string | null;
  total_spent: number;
  order_count: number;
}

export interface SalesRecommendation {
  title: string;
  action: string;
  expected_impact: string;
}

export interface SalesInsightSnapshot {
  id: number;
  period_start: string;
  period_end: string;
  order_count: number;
  total_revenue: number;
  average_order_value: number;
  unique_customer_count: number;
  repeat_customer_rate: number;
  top_products: TopProduct[];
  top_customers: TopCustomer[];
  ai_summary: string | null;
  ai_recommendations: SalesRecommendation[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GeneratePayload {
  days?: number;
}

export const salesInsightApi = {
  list: (page = 1) =>
    api.get<{ data: SalesInsightSnapshot[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/sales-insights?page=${page}`
    ),

  generate: (payload: GeneratePayload = {}) =>
    api.post<{ data: SalesInsightSnapshot }>('/sales-insights/generate', payload),

  show: (id: number) => api.get<{ data: SalesInsightSnapshot }>(`/sales-insights/${id}`),

  destroy: (id: number) => api.delete(`/sales-insights/${id}`),
};
